import { useState } from "react";

export const MUSES = [
  { name: "Imani", src: "https://cdn.shopify.com/s/files/1/0777/8956/0885/files/hf_20260926_131051_25221448-fe1e-4765-bc6b-d027bf632bcd.png" },
  { name: "Stella", src: "https://cdn.shopify.com/s/files/1/0777/8956/0885/files/hf_20260926_130819_dd51a1fb-4399-46e6-88c8-f748082ae1b0.png" },
  { name: "Valentina", src: "https://cdn.shopify.com/s/files/1/0777/8956/0885/files/hf_20260926_131234_07d9c083-41c6-4902-b877-be94da4fc17b.png" },
  { name: "Jade", src: "https://cdn.shopify.com/s/files/1/0777/8956/0885/files/hf_20260926_131144_8b5aff4e-f7ec-48ac-9c8c-1a38c8fac0a4.png" },
];

export function SafeImg({ className = "", wrapClass = "", lazy, ...p }) {
  const [ok, setOk] = useState(true);
  if (!ok) return null;
  return (
    <div className={wrapClass}>
      <img {...p} className={`w-full h-full object-cover ${className}`} loading={lazy ? "lazy" : "eager"} onError={() => setOk(false)} />
    </div>
  );
}

const thumb = "absolute rounded-[16px] overflow-hidden border-4 border-[#EFE9E1] shadow-[0_8px_30px_rgba(26,19,37,0.12)]";

export default function MuseCollage({ compact }) {
  const [main, ...rest] = MUSES;
  if (compact) {
    return (
      <div className="flex gap-2 h-full" data-testid="muse-collage-compact">
        {MUSES.map((m, i) => (
          <SafeImg key={m.name} src={m.src} alt={m.name} lazy={i > 0} className="object-top" wrapClass="h-full aspect-[3/4] rounded-[14px] overflow-hidden shrink-0" />
        ))}
      </div>
    );
  }
  return (
    <div className="relative rounded-[20px] bg-[#EFE9E1] p-4 sm:p-6 overflow-hidden" data-testid="muse-collage">
      <span className="chip absolute top-5 left-5 sm:top-7 sm:left-7 z-20 bg-[#F1E9FE]" data-testid="muse-collage-drop-pill">Certified Crush · Drop 001</span>
      <div className="relative w-[72%] aspect-[3/4]">
        <SafeImg src={main.src} alt={main.name} className="object-top" wrapClass="absolute inset-0 rounded-[20px] overflow-hidden" />
        <div className="absolute bottom-3 left-3 z-10 bg-white rounded-[16px] px-3 py-2 sm:px-4 sm:py-3 shadow-[0_8px_30px_rgba(26,19,37,0.12)]" data-testid="muse-collage-name-card">
          <p className="font-display text-xl sm:text-2xl">Imani, 26</p>
          <p className="text-[9px] sm:text-[10px] font-bold uppercase tracking-[0.14em] text-[#9C4DDC] mt-1 whitespace-nowrap">SoHo · High-fashion editorial</p>
        </div>
      </div>
      <SafeImg lazy src={rest[0].src} alt={rest[0].name} wrapClass={`${thumb} right-4 sm:right-6 top-[8%] w-[34%] aspect-[3/4] z-10`} />
      <SafeImg lazy src={rest[1].src} alt={rest[1].name} wrapClass={`${thumb} right-[6%] top-[42%] w-[30%] aspect-[3/4] z-[11]`} />
      <SafeImg lazy src={rest[2].src} alt={rest[2].name} wrapClass={`${thumb} right-4 sm:right-6 bottom-4 sm:bottom-6 w-[26%] aspect-square z-[12]`} />
    </div>
  );
}
